import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./ReusableDatePicker.css";
import { translateText, useTranslationSnapshot } from "./../translations/runtime";


const parseDateValue = (value) => {
  if (!value) return null;

  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatDateValue = (date) => {
  if (!date) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const allowedDateInputKeys = new Set([
  "Backspace",
  "Delete",
  "Tab",
  "Enter",
  "Escape",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
]);

const isDigitKey = (key) => /^\d$/.test(key);

const handleNumericDateKeyDown = (event) => {
  if (
    event.ctrlKey ||
    event.metaKey ||
    event.altKey ||
    allowedDateInputKeys.has(event.key)
  ) {
    return;
  }

  if (!isDigitKey(event.key)) {
    event.preventDefault();
  }
};

const handleNumericDatePaste = (event) => {
  const pastedText = event.clipboardData.getData("text");

  if (/\D/.test(pastedText)) {
    event.preventDefault();
  }
};

function ReusableDatePicker({
  ariaLabel,
  className = "",
  disabled = false,
  maxDate,
  minDate,
  onChange,
  placeholder = "DD/MM/YYYY",
  value,
}) {
  useTranslationSnapshot();
  return (
    <DatePicker
      aria-label={translateText(ariaLabel)}
      calendarClassName="reusable-date-picker-calendar"
      className={`reusable-date-picker-input ${className}`.trim()}
      dateFormat="dd/MM/yyyy"
      disabled={disabled}
      inputMode="numeric"
      maxDate={maxDate}
      minDate={minDate}
      onChange={(date) => onChange?.(formatDateValue(date))}
      onKeyDown={handleNumericDateKeyDown}
      onPaste={handleNumericDatePaste}
      placeholderText={placeholder}
      popperClassName="reusable-date-picker-popper"
      selected={parseDateValue(value)}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
    />
  );
}

export default ReusableDatePicker;
